"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Statuses = void 0;
var Statuses;
(function (Statuses) {
    Statuses[Statuses["suspended"] = 0] = "suspended";
    Statuses[Statuses["loading"] = 1] = "loading";
    Statuses[Statuses["notFound"] = 2] = "notFound";
    Statuses[Statuses["showing"] = 3] = "showing";
})(Statuses = exports.Statuses || (exports.Statuses = {}));
